import { api } from "./customers";

export interface ConsultantMaster {
  id: any;
  branchId: any;
  branchName: string;
  consultantName: string;
  speciality: string;
  email: string;
  revenue: string;
  phone1: string;
  languagesSpokenId: string; // assuming comma-separated string for multiple IDs
  languagesOthers: string;
  phone2: string;
  password: string;
  languages: string;
  activeStatus: any;
}

type MedicineMastersResponse = ConsultantMaster[];

export const ConsultantApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllConsultantLists: build.query<MedicineMastersResponse, any>({
      query: ({ pageNo, name }) =>
        `consultant_list?page=${pageNo}&filter=${name}`,
    }),
    getAllConsultantExpenses: build.query<MedicineMastersResponse, any>({
      query: ({ pageNo, name }) =>
        `consultant_payment_export?page=${pageNo}&filter=${name}`,
    }),
    getAllLanguages: build.query<any, any>({
      query: () => `languages`,
    }),
    addConsultant: build.mutation<any, Partial<any>>({
      query: (body: any) => ({
        url: `consultant_list`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: ConsultantMaster }, meta, arg) =>
        response.data,
    }),
    updateConsultant: build.mutation<
      void,
      Pick<ConsultantMaster, "id"> & Partial<ConsultantMaster>
    >({
      query: ({ id, ...patch }) => ({
        url: `consultant_list/${id}`,
        method: "PUT",
        body: patch,
      }),
    }),
    updateConsultantStatus: build.mutation<
      void,
      Pick<ConsultantMaster, "id"> & Partial<ConsultantMaster>
    >({
      query: ({ id, ...patch }) => ({
        url: `consultant_status/${id}`,
        method: "PUT",
        body: patch,
      }),
    }),
    deleteConsultant: build.mutation<{ success: boolean; id: number }, number>({
      query(id) {
        return {
          url: `consultant_list/${id}`,
          method: "DELETE",
        };
      },
    }),
    getConsultantDetails: build.query<any, any>({
      query: ({ id }) => `consultant_list/${id}`,
    }),
    getConsultantCalendarView: build.query<any, any>({
      query: ({ id }) => `appointment_calender?consultantId=${id}`,
    }),

    //Consultant Appointment

    getAllConsultantAppointment: build.query<MedicineMastersResponse, any>({
      query: ({ pageNo, name }) => `appointment?page=${pageNo}&filter=${name}`,
    }),

    getConsultantAppointmentCalculate: build.query({
      query: ({ startDate, endDate, consultantId }) =>
        `consultant_appointment_calculate?startDate=${startDate}&endDate=${endDate}&consultantId=${consultantId}`,
    }),

    createConsultantPayment: build.mutation({
      query: (body) => ({
        url: `consultant_payment`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllConsultantListsQuery,
  useAddConsultantMutation,
  useUpdateConsultantMutation,
  useDeleteConsultantMutation,
  useGetAllLanguagesQuery,
  useUpdateConsultantStatusMutation,
  useGetConsultantDetailsQuery,
  useGetConsultantCalendarViewQuery,
  useGetAllConsultantExpensesQuery,
  useGetAllConsultantAppointmentQuery,
  useGetConsultantAppointmentCalculateQuery,
  useCreateConsultantPaymentMutation,
} = ConsultantApi;
